export const eventpagetext = {
    category: "Catégorie",
    title: "Titre",
    description: "Description",
    groups: "Groupe",
    datebegin: "Date de l'évènement",
    dateend:"Date de fin",
    status:"Statut",
    author:"Auteur",
}